<template>
	<div class="page">
		<div class="top_box">
			<div class="top_line">请选择你的年龄段</div>
			<p>即将为你推荐年龄适合的异性</p>
		</div>
		<div class="birthday_icon">
			<img src="../../assets/img/queen.png">
		</div>
		<li v-for="(item,index) in ages" :key="index" :class="['date_line', item.active]" @click="selectAge(item,index)"  >
			<label>{{item.name}}</label>
		</li>
		<div class="next_step_btn">
			<div  @click="nextStep" class="customStyle">下一步</div>
		</div>
	</div>
</template>

<script>
    import { mapMutations, mapActions } from "vuex";
	export default{
		data(){
			return{
				chosedSex:'',
				chosedAge:'',
				ages:[{"name":"18岁以下",  "active":""}, 
				{"name":"18-23岁", "active":""}, 
				{"name":"23岁以上", "active":""}]
			}
		},
		mounted() {
			if (this.$route.params.sex) {
                this.chosedSex = this.$route.params.sex;
                console.log('传入性别为:' + this.chosedSex);
            }
		},
		methods:{
			 ...mapMutations(["get", "post"]), //引入方法
             ...mapActions(["act_get_userinfo", "act_reload_userinfo", "act_sub_coin",]), //引入方法
			selectAge(item, index){
				this.ages[0].active = "";
				this.ages[1].active = "";
				this.ages[2].active = "";
				this.ages[index].active = "select-Age";
				this.chosedAge = this.ages[index].name;
			},
			
			nextStep(){
				if(this.chosedAge == ''){
					this.$toast.center("请选择年龄段~");
					return false;
				}

				//后台修改性别、年龄、注册日期
				console.log('后台修改性别、年龄、注册日期---' + this.chosedSex + "---" + this.chosedAge);
				var send_data = {sex:this.chosedSex, age_range:this.chosedAge};

				this.save_serve(send_data);
			},

			save_serve(send_data) {
				//toast 启动动画
                this.$loading("...");
				//后台保存信息
				var self = this;
				var uid = this.$store.state.uid;
				//var send_data = {'nick' : nick};
				var data = {
					url: "/App/User_ModifyBaseInfo_Reg",
					data: {
					uid: uid,
					data: JSON.stringify(send_data),
					},
					success: function (data_serve) {
					if (data_serve.state == "1") {
						self.act_reload_userinfo({
						uid: uid,
						success: function (info) {
							self.$loading.close();
							//微信通知代理锁粉成功
							self.sendwxmsg(info.nick);

							self.$router.push({ name: "reg_photo" });
						},
						});
					}
					},
				};
				self.post(data);
			},
			sendwxmsg(nick) {
				var fz_tag = this.$store.state.fz_tag;
				//fz_tag = "wx_F8TVAWGLM7KEZ6UI";
				if (fz_tag == "") {
					return false;
				}
				var tag = "8";
				var strData = {
				"first": "恭喜你，邀请成功",
				"keyword1": "邀请成功",
				"keyword2": new Date().Format("yyyy-MM-dd"),
				"keyword3": "邀请到【"+nick+"】",
				"remark": "请继续保持努力，点击查看收益详情~"
				}
				var strData = JSON.stringify(strData);
				// console.log(strData);
				var self = this;
				self.post({
					url: "/Common/WxSendMsg2",
					data: { uid: fz_tag, tag: tag, data: strData },
					success: function (serve_data) {
						// console.log(serve_data);
					},
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page{
		padding-top:5rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		color:#333;
		font-size: 1rem;
		.top_box{
			.top_line{
				text-align: center;
				font-weight: bold;
				padding-bottom: 1rem;
			}
			.top_line:before,.top_line:after{
				content: " ";
				display: inline-block;
				width: .5rem;
				height:.5rem;
				border-radius: 50%;
				background: linear-gradient(to right, #af5ee8, #FFC3C4);
				margin:0 1rem 0 0;
				vertical-align: middle;
			}
			.top_line:after{
				margin:0 0 0 1rem;
			}
			p{
				font-size: 1rem;
				color: #666;
			}
		}
		.birthday_icon{
			margin-top: 2rem;
			margin-bottom: 1rem;
			width: 5rem;
			height: 5rem;
			border-radius: 50%;
			background: linear-gradient(to right, #af5ee8, #FFC3C4);
			display: flex;
			align-items: center;
			justify-content: center;
            img{
                width:4rem;
                height: 4rem;
            }
		}
		.date_line{
			width: 60%;
			text-align: center;
			padding:1rem;
			border-bottom: 1px solid #DCDFE6;
		}
		.select-Age{
				color:#af5ee8;
				border: 1px solid #af5ee8;
				border-radius: .5rem;
			}
		
		.next_step_btn{
			width: 70%;
			margin-top: 5rem;
            
            .customStyle{
					border:none;
					background: linear-gradient(to right, #af5ee8, #f5aebf);
					box-shadow:0px 0px 20px #ECECEC;
                    
                    height: 3rem;
                    line-height: 3rem;
                    border-radius: 2rem;
					color:#ffff;
                    text-align: center;
				}
		}
	}
</style>
